import React from 'react';
import ReactDOM from 'react-dom/client';
import Generator from './Generator';


const root = ReactDOM.createRoot(document.getElementById('root'));





root.render(
  < Generator/>
)


